module.exports = __webpack_public_path__ + "media/images/moovc-e44840bc327c91f676295b6a23185458.png";